import chunk from 'lodash/chunk'
import { escapeHtml } from '@messenger/utils'
import handleHtmlData from 'utils/global/handleHtmlData'
import getThemeStylesForTemplate from 'utils/tinyMCE/templates/getThemeStylesForTemplate'

const tableData = ({ value, styles, selectedTheme, editor }) => {
  const { attributes } = styles
  const encodedValue = handleHtmlData.encode(value)
  let style = attributes?.style || ''

  const themeStyles = getThemeStylesForTemplate({
    selectedTheme,
    editor,
  })
  style = `${style} ${themeStyles}`.trim()

  // A cell holds a case value (a pallbearer's or clergy name): text, never markup.
  const cellContent = `<span class="mceNonEditable" data-template-item="${encodedValue}" style="${style}">${escapeHtml(String(value ?? ''))}</span>`

  return `
    <td>
      ${cellContent}
    </td>
  `
}

const tableRow = ({ chunk, styles, selectedTheme, editor }) => {
  const item = chunk
    .map((value) => tableData({ value, styles, selectedTheme, editor }))
    .join('')

  return `<tr>${item}</tr>`
}

export const tableTemplate = ({
  path,
  items,
  columns = 2,
  styles = {},
  selectedTheme,
  editor,
}) => {
  const chunked = chunk(items, columns)
  const { attributes } = styles
  const dataStyle = attributes?.styleData || ''

  return `
    <div data-case-detail-table="${path}" class="mceNonEditable caseDetailTable" ${dataStyle}>
      <table>
        <tbody>
          ${chunked
            .map((chunk) => tableRow({ chunk, styles, selectedTheme, editor }))
            .join('')}
        </tbody>
      </table>
    </div>
`
}

export default tableTemplate
